export default __webpack_public_path__ + "static/media/13.bc6fc925.jpg";